module.exports = __webpack_public_path__ + "static/media/hero-1140.d2a1ae46.jpg";